var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showWidget)?_c('section',{attrs:{"id":"calculatorWidget"},on:{"click":_vm.onWidgetClick}},[_c('i',{staticClass:"icon icon-calc"},[_vm._v("  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }